// Hash-based SPA router
const routes = new Map();
let currentCleanup = null;

export function route(pattern, handler) {
  routes.set(pattern, handler);
}

export function navigate(hash) {
  window.location.hash = hash;
}

function matchRoute(hash) {
  const path = hash.replace(/^#/, '') || '/explore';

  for (const [pattern, handler] of routes) {
    // Convert pattern like '/editor/:id' to regex
    const paramNames = [];
    const regexStr = pattern.replace(/:([^/]+)/g, (_, name) => {
      paramNames.push(name);
      return '([^/]+)';
    });
    const match = path.match(new RegExp(`^${regexStr}$`));
    if (match) {
      const params = {};
      paramNames.forEach((name, i) => { params[name] = match[i + 1]; });
      return { handler, params };
    }
  }
  return null;
}

export function startRouter() {
  function onHashChange() {
    // Hide all pages
    document.querySelectorAll('.page').forEach(p => p.classList.remove('active'));

    // Run cleanup from previous route
    if (currentCleanup) {
      currentCleanup();
      currentCleanup = null;
    }

    const result = matchRoute(window.location.hash);
    if (result) {
      currentCleanup = result.handler(result.params) || null;
    } else {
      // Default to explore
      navigate('/explore');
    }
  }

  window.addEventListener('hashchange', onHashChange);

  // Initial route
  if (!window.location.hash) {
    window.location.hash = '/explore';
  } else {
    onHashChange();
  }
}
